// MT home dashboard (zone layout) strings: mtdScorecards. Keys use the "mtd-" prefix.
export default {
  en: {
    'mtd-scorecards-title': 'Scorecards',
    'mtd-scorecards-meta': '{n} scorecards · actual vs goal',
    'mtd-scorecards-meta-phone': '{n} scorecards · swipe for more',
    'mtd-scorecards-new': 'New scorecard',
    'mtd-scorecards-settings': 'Scorecard settings',
    'mtd-scorecards-edit': 'Edit scorecard',
    'mtd-scorecards-rank': 'Rank locations',
    'mtd-scorecards-empty': 'No scorecards yet.',
    'mtd-scorecards-empty-viewer':
      'No scorecards yet. Ask your organization admin to add one.',
    'mtd-scorecards-no-metrics': 'No metrics selected',
    'mtd-scorecards-no-data': 'No data for this period',
    'mtd-scorecards-metric': 'Metric',
    'mtd-scorecards-actual': 'Actual',
    'mtd-scorecards-goal': 'Goal',
    'mtd-scorecards-goal-hit': 'Goal met',
    'mtd-scorecards-goal-miss': 'Goal missed',
    'mtd-scorecards-page': 'Scorecard {n}',
    'mtd-scorecards-pinned': 'Pinned to {period} · {range}',
    'mtd-scorecards-period-YEST': 'yesterday',
    'mtd-scorecards-period-WTD': 'week to date',
    'mtd-scorecards-period-MTD': 'month to date',
    'mtd-scorecards-period-YTD': 'year to date',
    'mtd-scorecards-period-LW': 'last week',
    'mtd-scorecards-period-LM': 'last month',
    'mtd-scorecards-period-Custom': 'a custom range',
  },
  es: {
    'mtd-scorecards-title': 'Scorecards',
    'mtd-scorecards-meta': '{n} scorecards · real vs meta',
    'mtd-scorecards-meta-phone': '{n} scorecards · desliza para ver más',
    'mtd-scorecards-new': 'Nuevo scorecard',
    'mtd-scorecards-settings': 'Configuración de scorecards',
    'mtd-scorecards-edit': 'Editar scorecard',
    'mtd-scorecards-rank': 'Clasificar ubicaciones',
    'mtd-scorecards-empty': 'Aún no hay scorecards.',
    'mtd-scorecards-empty-viewer':
      'Aún no hay scorecards. Pide al administrador de tu organización que agregue uno.',
    'mtd-scorecards-no-metrics': 'No se han seleccionado métricas',
    'mtd-scorecards-no-data': 'Sin datos para este periodo',
    'mtd-scorecards-metric': 'Métrica',
    'mtd-scorecards-actual': 'Real',
    'mtd-scorecards-goal': 'Meta',
    'mtd-scorecards-goal-hit': 'Meta cumplida',
    'mtd-scorecards-goal-miss': 'Meta no cumplida',
    'mtd-scorecards-page': 'Scorecard {n}',
    'mtd-scorecards-pinned': 'Fijado a {period} · {range}',
    'mtd-scorecards-period-YEST': 'ayer',
    'mtd-scorecards-period-WTD': 'semana a la fecha',
    'mtd-scorecards-period-MTD': 'mes a la fecha',
    'mtd-scorecards-period-YTD': 'año a la fecha',
    'mtd-scorecards-period-LW': 'la semana pasada',
    'mtd-scorecards-period-LM': 'el mes pasado',
    'mtd-scorecards-period-Custom': 'un rango personalizado',
  },
  fr: {
    'mtd-scorecards-title': 'Tableaux de bord',
    'mtd-scorecards-meta': '{n} tableaux de bord · réel vs objectif',
    'mtd-scorecards-meta-phone': '{n} tableaux de bord · balayez pour plus',
    'mtd-scorecards-new': 'Nouveau tableau de bord',
    'mtd-scorecards-settings': 'Paramètres des tableaux de bord',
    'mtd-scorecards-edit': 'Modifier le tableau de bord',
    'mtd-scorecards-rank': 'Classer les établissements',
    'mtd-scorecards-empty': 'Aucun tableau de bord pour le moment.',
    'mtd-scorecards-empty-viewer':
      "Aucun tableau de bord pour le moment. Demandez à l'administrateur de votre organisation d'en ajouter un.",
    'mtd-scorecards-no-metrics': 'Aucune mesure sélectionnée',
    'mtd-scorecards-no-data': 'Aucune donnée pour cette période',
    'mtd-scorecards-metric': 'Mesure',
    'mtd-scorecards-actual': 'Réel',
    'mtd-scorecards-goal': 'Objectif',
    'mtd-scorecards-goal-hit': 'Objectif atteint',
    'mtd-scorecards-goal-miss': 'Objectif manqué',
    'mtd-scorecards-page': 'Tableau de bord {n}',
    'mtd-scorecards-pinned': 'Épinglé à {period} · {range}',
    'mtd-scorecards-period-YEST': 'hier',
    'mtd-scorecards-period-WTD': 'la semaine à ce jour',
    'mtd-scorecards-period-MTD': 'le mois à ce jour',
    'mtd-scorecards-period-YTD': "l'année à ce jour",
    'mtd-scorecards-period-LW': 'la semaine dernière',
    'mtd-scorecards-period-LM': 'le mois dernier',
    'mtd-scorecards-period-Custom': 'une période personnalisée',
  },
  'fr-ca': {
    'mtd-scorecards-title': 'Tableaux de bord',
    'mtd-scorecards-meta': '{n} tableaux de bord · réel vs objectif',
    'mtd-scorecards-meta-phone': '{n} tableaux de bord · glissez pour plus',
    'mtd-scorecards-new': 'Nouveau tableau de bord',
    'mtd-scorecards-settings': 'Paramètres des tableaux de bord',
    'mtd-scorecards-edit': 'Modifier le tableau de bord',
    'mtd-scorecards-rank': 'Classer les établissements',
    'mtd-scorecards-empty': 'Aucun tableau de bord pour l’instant.',
    'mtd-scorecards-empty-viewer':
      "Aucun tableau de bord pour l’instant. Demandez à l'administrateur de votre organisation d'en ajouter un.",
    'mtd-scorecards-no-metrics': 'Aucune mesure sélectionnée',
    'mtd-scorecards-no-data': 'Aucune donnée pour cette période',
    'mtd-scorecards-metric': 'Mesure',
    'mtd-scorecards-actual': 'Réel',
    'mtd-scorecards-goal': 'Objectif',
    'mtd-scorecards-goal-hit': 'Objectif atteint',
    'mtd-scorecards-goal-miss': 'Objectif manqué',
    'mtd-scorecards-page': 'Tableau de bord {n}',
    'mtd-scorecards-pinned': 'Épinglé à {period} · {range}',
    'mtd-scorecards-period-YEST': 'hier',
    'mtd-scorecards-period-WTD': 'la semaine à ce jour',
    'mtd-scorecards-period-MTD': 'le mois à ce jour',
    'mtd-scorecards-period-YTD': "l'année à ce jour",
    'mtd-scorecards-period-LW': 'la semaine dernière',
    'mtd-scorecards-period-LM': 'le mois dernier',
    'mtd-scorecards-period-Custom': 'une période personnalisée',
  },
};
